import { SLUGS_PATH } from 'cpmWorkspaces/navigation';

module.exports = {
  path: SLUGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/WorkspaceSlugs'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/routes/slugs/index.js